// eslint-disable-next-line
export const PASSWORD_REGEX = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*)[a-zA-Z0-9()_@!.\/\\|"'^#*&%$+\-]+$/g;
// eslint-disable-next-line
export const EMAIL_REGEX = /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
// eslint-disable-next-line
export const PHONE_REGEX = /^[+]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\.\/0-9]{6,15}$/;

export function testPasswordRegex(value) {
    PASSWORD_REGEX.lastIndex = 0;
    return PASSWORD_REGEX.test(value);
}

export function testEmailRegex(emailAddress) {
    return EMAIL_REGEX.test(emailAddress);
}

export function testPhoneRegex(phoneNumber) {
    return PHONE_REGEX.test(phoneNumber);
}